export const T = {
  en_GB: {
    edit: "Edit",
    addPortfolio: "Add Portfolio",
    riskScoreDesc: (p: { min: string; max: string; name: string }) =>
      `Configure portfolios for risk scores ${p.min}-${p.max} (based on ${p.name})`,
    noRiskModelDesc: "Configure portfolios for this collection",
    noPortfolios: 'No portfolios configured. Click "Add Portfolio" to create one.',
    riskScore: "Risk Score",
    name: "Name",
    products: "Products",
    platforms: "Platforms",
    weight: "Weight",
    active: "Active",
    actions: "Actions",
    product: "product",
    productsPlural: "products",
    deletePortfolioTitle: "Delete Portfolio",
    deletePortfolioDescription:
      "Are you sure you want to delete this portfolio? This action cannot be undone and will remove all associated products.",
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    portfolioDeleted: "Portfolio deleted successfully",
    failedToUpdate: "Failed to update portfolio",
    failedToDelete: "Failed to delete portfolio",
  },
  nb_NO: {
    edit: "Rediger",
    addPortfolio: "Legg til portefølje",
    riskScoreDesc: (p: { min: string; max: string; name: string }) =>
      `Konfigurer porteføljer for risikoscore ${p.min}-${p.max} (basert på ${p.name})`,
    noRiskModelDesc: "Konfigurer porteføljer for denne samlingen",
    noPortfolios: 'Ingen porteføljer konfigurert. Klikk "Legg til portefølje" for å opprette en.',
    riskScore: "Risikoscore",
    name: "Navn",
    products: "Produkter",
    platforms: "Plattformer",
    weight: "Vekting",
    active: "Aktiv",
    actions: "Handlinger",
    product: "produkt",
    productsPlural: "produkter",
    deletePortfolioTitle: "Slett portefølje",
    deletePortfolioDescription:
      "Er du sikker på at du vil slette denne porteføljen? Denne handlingen kan ikke angres og vil fjerne alle tilknyttede produkter.",
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    portfolioDeleted: "Porteføljen ble slettet",
    failedToUpdate: "Kunne ikke oppdatere portefølje",
    failedToDelete: "Kunne ikke slette portefølje",
  },
} as const;
